<template lang="pug">
    .card_content
        .card_thumbnail
            .card_thumbnail_img(v-if="article.thumbnail === null" :style="{backgroundImage: 'url(' + defaultThumbnail + ')'}")
            .card_thumbnail_img(v-else :style="{backgroundImage: 'url(' + article.thumbnail + ')'}")
        .card_item
            .card_item_header(v-if="showCategory || showDate")
                span.card_category(v-if="showCategory") {{ article.category.screen_name }}
                span.card_date(v-if="showDate") {{ formattedDate(article.published_at) }}
            .card_title {{ article.title }}
</template>

<script>
export default {
    name: 'PublicRelatedArticleCard',
    props: [
        'article'
    ],
    data(){
        return {
            defaultThumbnail: '/img/thumb_default.jpg'
        }
    },
    computed: {
        showCategory() {
            return this.article.category
        },
        showDate() {
            return ['news', 'articles'].includes(this.article.category.slug)
        },
        formattedDate() {
            return function (date) {
                if(date){
                    date = date.slice(0, 10).replace(/\//g, '.').replace(/-/g, '.')
                    return date
                }
            }
        }
    },
}
</script>